export default "__VITE_ASSET__BlJ2HU2U__"